import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { C } from "../ipd-billing/constants";

function Detail({ label, value }) {
  return (
    <div>
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: C.textSub,
          textTransform: "uppercase",
          letterSpacing: "0.04em",
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 13, fontWeight: 600, color: C.text, marginTop: 3 }}>
        {value || "—"}
      </div>
    </div>
  );
}

/**
 * Diagnostic doctor review: patient details + PDF of this order's report.
 * Sign / Reject / Publish are passed in as footerExtra.
 * Optional headerExtra (e.g. View patient condition) sits beside Close.
 */
export default function DiagnosticReportPdfModal({
  title,
  details = [],
  pdfUrl,
  pdfLoading,
  headerExtra,
  footerExtra,
  overlay,
  onClose,
  onDownload,
}) {
  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(15,23,42,0.55)",
          zIndex: 2000,
        }}
      />
      <div
        style={{
          position: "fixed",
          inset: "4% 8%",
          zIndex: 2001,
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 12,
            padding: "14px 18px",
            borderBottom: `1px solid ${C.border}`,
            flexShrink: 0,
          }}
        >
          <div>
            <Typography sx={{ fontWeight: 700, fontSize: 18, color: C.text }}>
              {title}
            </Typography>
            <Typography sx={{ fontSize: 13, color: C.textSub, mt: 0.3 }}>
              Review the report PDF, then sign or reject.
            </Typography>
          </div>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              flexShrink: 0,
            }}
          >
            {headerExtra}
            <Button onClick={onClose} variant="outlined" size="small">
              Close
            </Button>
          </div>
        </div>

        <Box
          sx={{
            px: 2.5,
            py: 2,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
            gap: 1.5,
            borderBottom: `1px solid ${C.border}`,
            flexShrink: 0,
            background: "#f8fafc",
          }}
        >
          {details.map((d) => (
            <Detail key={d.label} label={d.label} value={d.value} />
          ))}
        </Box>

        <div
          style={{
            flex: 1,
            minHeight: 0,
            background: "#e8edf3",
            position: "relative",
          }}
        >
          {pdfLoading ? (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : pdfUrl && !overlay ? (
            <iframe
              title="Report PDF"
              src={pdfUrl}
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          ) : overlay ? null : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 3,
              }}
            >
              <Typography color="text.secondary">
                Report PDF is not available for this order yet.
              </Typography>
            </Box>
          )}
          {overlay ? (
            <div
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(15,23,42,0.45)",
              }}
            >
              {overlay}
            </div>
          ) : null}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            padding: "12px 18px",
            borderTop: `1px solid ${C.border}`,
            flexShrink: 0,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              marginRight: "auto",
            }}
          >
            {footerExtra}
          </div>
          {pdfUrl && onDownload ? (
            <Button variant="outlined" size="small" onClick={onDownload}>
              Download PDF
            </Button>
          ) : null}
        </div>
      </div>
    </>
  );
}
